import * as actions from './actions';
import * as components from './components';
import * as constants from './constants';
import reducer from './reducer';
//import * as selectors from './selectors';

export default { actions, components, constants, reducer, /*selectors*/ };




// WEBPACK FOOTER //
// ./src/user/index.js